import { getLocale } from "../runtime";

const sv_continuetonextstep = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Nästa steg`
};

const continuetonextstep = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_continuetonextstep(inputs)
	return "continueToNextStep";
};

export { continuetonextstep as "continueToNextStep" };